import React from 'react';
import { generateExceptZeroArray } from '../../../../utils/constant';
import Modal from '../../../../component/modal/Modal';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import Button from '../../../../component/ui/Button';

export default function CompareCustomerReportModel({
	compareModelOpen,
	setCompareModelOpen,
	params,
	setParams,
	getCustomerReportList,
}) {
	const comparePeriodYearlist = [
		{ key: 'previous_year', value: 'Previous Year' },
		{ key: 'previous_period', value: 'Previous Period' },
	];
	const noOfYearPeriodList = generateExceptZeroArray(10);

	const handleFormData = (key, value, inputType, required = false) => {
		setParams((prev) => ({
			...prev,
			[key]: value,
		}));
		// let newError = { ...error };
		// if (required) {
		// 	if (value !== '' && value !== undefined && value !== null) {
		// 		delete newError[key];
		// 	} else {
		// 		newError[key] =
		// 			inputType === 'field'
		// 				? `Please enter ${key.replaceAll('_', ' ')} in the field.`
		// 				: `Please select a valid ${key.replaceAll('_', ' ')} from the list.`;
		// 	}
		// }
		// setError(newError);
	};

	return (
		<div>
			<Modal
				className="compare-report-modal"
				title={`Compare With`}
				isOpen={compareModelOpen}
				onClose={() => {
					setCompareModelOpen(false);
				}}
				cancelButton={() => {
					setCompareModelOpen(false);
				}}
			>
				<div>
					<div className="col">
						<InputSelect
							options={comparePeriodYearlist}
							label="Compare Based on Period/Year "
							placeholder="Select Period/Year"
							required={false}
							autoComplete="off"
							disabled={false}
							returnInputValue={false}
							value={params?.compare_type}
							onChange={(value) => {}}
							onSelect={(option) => handleFormData('compare_type', option.key)}
						/>
					</div>
					<div className="col">
						<InputSelect
							options={noOfYearPeriodList}
							label="Compare Number of Year(s)"
							placeholder="Select Number of Years"
							required={false}
							autoComplete="off"
							disabled={false}
							returnInputValue={false}
							value={params?.compare_count}
							onChange={(value) => {}}
							onSelect={(option) => handleFormData('compare_count', option.key)}
						/>
					</div>
					<div className="d-flex gap-3 align-items-center my-2">
						<div className="form-check">
							<input
								class="form-check-input"
								type="checkbox"
								checked={params?.is_arrange_year_period}
								id="flexCheckDefault"
								onChange={(e) =>
									handleFormData('is_arrange_year_period', !params?.is_arrange_year_period)
								}
							/>
						</div>
						<div className="fs-5 fw-semibold text-dark">
							Arrange period/year from latest to oldest
						</div>
					</div>
					<div className="d-flex align-items-center justify-content-end my-4 gap-4">
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => {
								setCompareModelOpen(false);
								setParams((prev) => ({
									...prev,
									compare_type: null,
									compare_count: null,
									is_arrange_year_period: true,
								}));
							}}
						/>
						<Button
							type="button"
							button={`Apply`}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setCompareModelOpen(false);
								getCustomerReportList();
							}}
						/>
					</div>
				</div>
			</Modal>
		</div>
	);
}
